var _radialGradient, _linearGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _linearGradient2, _radialGradient7, _radialGradient8, _radialGradient9, _linearGradient3, _radialGradient10, _radialGradient11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__d",
    cx: 431.157,
    cy: 1004.275,
    r: 211.111,
    gradientTransform: "matrix(.931 0 0 .114 -148.108 282.567)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1f4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#e9f9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "#e9f9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#fff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bookmark_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#d6f6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68e7fd"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__e",
    cx: 214.418,
    cy: 83.02,
    r: 97.427,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__a"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__f",
    cx: 97.269,
    cy: 141.594,
    r: 87.953,
    gradientTransform: "matrix(1 0 0 .763 0 33.525)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__a"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__g",
    cx: 57.349,
    cy: 268.345,
    r: 161.174,
    gradientTransform: "matrix(1 0 0 .573 0 114.637)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1693,
    stopColor: "#42e3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#00dcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    stopColor: "#00c1fc"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__h",
    cx: 49.388,
    cy: 198.505,
    r: 80.486,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__a"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__i",
    cx: 518.101,
    cy: 266.343,
    r: 437.907,
    gradientTransform: "matrix(-1 0 0 -.767 1036.202 470.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#00c1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#0094ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bookmark_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#ddf7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    stopColor: "#daf7c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#c4f19b"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__j",
    cx: 277.943,
    cy: 217.515,
    r: 53.844,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__b"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__k",
    cx: 256.556,
    cy: 355.099,
    r: 83.237,
    gradientTransform: "matrix(1 0 0 .528 0 167.558)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#a4ed62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7855,
    stopColor: "#85e026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#72d800"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__l",
    cx: 225.665,
    cy: 255.535,
    r: 114.712,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__b"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bookmark_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7be700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#72d800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8085,
    stopColor: "#26b847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#00a96a"
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__m",
    cx: 440.012,
    cy: 272.799,
    r: 151.727,
    gradientTransform: "matrix(0 1 -.608 0 570.979 -167.213)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__c"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "bookmark_svg__n",
    cx: 317.388,
    cy: 291.654,
    r: 117.402,
    gradientTransform: "matrix(0 1 -.648 0 506.289 -25.735)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#bookmark_svg__c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__d)",
    d: "M256 422.4c113.107 0 204.798-11.461 204.798-25.6H51.202c0 14.139 91.691 25.6 204.798 25.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__e)",
    d: "M321.6 89.6c-46.824 0-79.536 43.979-104 80l-85.382-20.314C156.682 113.265 197.976 89.6 244.8 89.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__f)",
    d: "M54.591 202.977a54.987 54.987 0 01-.191-4.577c0-30.044 24.356-54.4 54.4-54.4h76.8c-30.044 0-54.335 57.468-54.209 58.977z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__g)",
    d: "M81.6 361.6C36.534 361.6 0 325.066 0 280l115.2-33.6c0 45.066-1.866 115.2 43.2 115.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__h)",
    d: "M0 280c0-35.6 22.798-65.875 54.591-77.023h76.8C99.598 214.125 115.199 244.4 115.199 280z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__i)",
    d: "M455.622 202.373C444.6 138.328 388.791 89.6 321.6 89.6c-46.824 0-88.118 23.665-112.582 59.686A54.187 54.187 0 00185.6 144c-30.044 0-54.4 24.356-54.4 54.4 0 1.541.065 3.068.191 4.577C99.598 214.125 76.8 244.4 76.8 280c0 45.066 36.534 81.6 81.6 81.6h272c45.066 0 81.6-36.534 81.6-81.6 0-36.264-23.656-67.003-56.378-77.627z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__j)",
    d: "M217.6 243.2l76.8-25.6H320L243.199 256z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__k)",
    d: "M238.984 358.4a99.882 99.882 0 0033.894 27.639L294.4 396.8H320l-12.8-51.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__l)",
    d: "M243.2 243.2h-25.6v53.397a99.961 99.961 0 0021.384 61.803H300.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__m)",
    d: "M320 217.6l-12.8 64L320 396.8l21.521-10.761C375.4 369.1 396.8 334.474 396.8 296.597V243.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bookmark_svg__n)",
    d: "M243.2 243.2v53.397c0 37.877 21.4 72.503 55.279 89.443L320 396.8V217.6z"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgBookmark as ReactComponent };